import * as React from "react";
import Spinner from '../common/spinner';
import { connect } from "react-redux";
import GenericInput from "../common/input/GenericInput";
import DatePicker from "../common/DatePicker";
import Email from "../common/input/Email";
import ZipCode from "../common/input/ZipInput";
import * as types from "../../constants/actionTypes";
import * as Tools from "../../helpers/Tools";
import DataComponent from "../common/DataComponent";
import { logUI } from "../../api/andyliticsApi";
import { Link } from "react-router-dom";

export const initialState = {
    fields: {
        email: "",
        dob: "",
        firstName: "",
        lastName: "",
        zipCode: "",
    },
    errors: {
    },
    showErrors: false
};

/**
 * Container component for the Forgot Username page.
 * 
 */
class ForgotUsername extends DataComponent {
    constructor(props) {
        super(props);

        this.state = Tools.deepCopy( initialState);

        this.getUserName = this.getUserName.bind(this);
        this.isFormValid = this.isFormValid.bind(this);
    }

    componentDidMount() {
        if (super.componentDidMount) { super.componentDidMount(); }
        logUI("MBHWeb.UI.ForgotUsername.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    componentWillUnmount() {
        super.componentWillUnmount();
        const { ClearForgotState } = this.props;
        this.setState( Tools.deepCopy( initialState));
        ClearForgotState();
    }

    getUserName() {
        if (!this.isFormValid()) {
            return false;
        }
        const { email, dob, firstName, lastName, zipCode } = this.state.fields;
        const { onForgotBtnClick } = this.props;

        onForgotBtnClick(email, Tools.getFormattedDate(dob), firstName, lastName, zipCode);
        logUI("MBHWeb.Settings.ForgotUsername", new Date(), Tools.getURLPath());
    }

    isFormValid() {
        const { email, dob, firstName, lastName, zipCode } = this.state.fields;
        let isFormValid = false;
        if (this.isValidEmail(email) && Tools.isValidDate(dob) && !Tools.isFutureDate(dob) && !Tools.isEmptyString(firstName) && !Tools.isEmptyString(lastName)
            && Tools.isValidZipCode(zipCode)) {
            isFormValid = true;
        } 
        this.setState({ showErrors: !isFormValid });
        return isFormValid;
    }

    isValidEmail = (thisEmail) => {
        try {
            thisEmail = thisEmail || "";
            const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return regex.test(thisEmail);
        }
        catch (e) {
            return false;
        }
    };

    onInputChange = (e, field, isValid) => {
        const value = e && e.target && e.target.value ? e.target.value : "";
        if (field === "dob")
            this.onDobChange(e, 'dob');
        else
            this.handleInputChange(e);
        let msg = "";
        if (value && !isValid) {
            switch (field) {
                case "email":
                    msg = "Please enter a valid email address.";
                    break;
                case "dob":
                    msg = "Please enter a valid date of birth.";
                    break;
                case "firstName":
                    msg = "Please enter your first name.";
                    break;
                case "lastName":
                    msg = "Please enter your last name.";
                    break;
                case "zipCode":
                    msg = "Please enter a 5 digit zip code.";
                    break;
                default:
                    msg = "";
            }
        }
        this.setState({ errors: { ...this.state.errors, [field]: msg } }, () => {
            if (this.checkValidity(this.state.errors)) this.setState({ showErrors: false });
        });
    }

    checkValidity = (object) => {
       let isValid = true;
        Object.keys(object).forEach(key => { if (object[key]) isValid = false; });
       return isValid;
    }

     render() {
        var isClientSide = typeof window !== 'undefined';
        const { helpDeskNumber, serviceError, successResponse, failureResponse } = this.props;
        const serviceWaitings = (this.props.serviceWaiting === false || this.props.serviceWaiting === undefined) ? false : true;
         const { errors, showErrors } = this.state;
        window.componentChanged = false;
        return (
            <div className="container-fluid body-logged-out forgot-un-container">
                <div className={"row " + (showErrors ? " form-submitted " : "")}>
                    <div className="col-12 page-form-sm">
                        <div className="row forgot-un-logo">
                            <div className="col-12 text-center">
                                <Link to="/login">
                                    <img alt="my-bsw-health-logo" src="/images/mybswhlogo.png" className="img-fluid" />
                                </Link>
                            </div>
                        </div>
                        {!successResponse &&
                            <div className="row forgot-un-heading">
                                <div className="col-12 text-center">
                                    <h1 className="page-heading form-heading">Forgot Your MyBSWHealth Username?</h1>
                                </div>
                            </div>
                        }                        
                        <div className="row forgot-un-form">                            
                            {(serviceError || (failureResponse && successResponse === null)) && <div className="col-12 text-center error-msg">
                                <div>{failureResponse}{serviceError}</div>
                            </div>}
                            {successResponse ?
                                <div className="col-12 text-center success-msg success-banner-container">
                                    <div className="status-icon-container"><span className='icon-list-check' /></div>
                                    <div className="col-12 status-banner-msg">
                                        <h1>Your request was successful.</h1>
                                    </div>
                                    <div className={`status-subBanner-container`}>
                                        <div className="col-12 status-subBanner-msg">
                                            <h2>{successResponse}</h2>
                                        </div>
                                    </div>
                                </div> :
                                <React.Fragment>
                                    {showErrors &&
                                        <div className="col-12 text-center error-msg">
                                            <div>Complete required fields.</div>
                                        </div>
                                    }
                                    <div className="col-12 form-group">
                                        <Email placeholder="Email Address"
                                            value={this.state.fields["email"]} name="email"
                                            onChange={(e, isValid) => { this.onInputChange(e, "email", isValid) }}
                                            inputErrorMsg={errors.email}
                                            required
                                            showClearBtn
                                            showAsInvalid={errors && errors.email}
                                        />
                                    </div>
                                    <div className="col-12 form-group">
                                        <DatePicker value={this.state.fields["dob"]} name="dob"
                                            type="text" yearsBackward={140} maxDate={new Date()}
                                            onChange={(value, isValid) => { this.onInputChange(value, "dob", isValid) }}
                                            required
                                            showClearBtn
                                            showAsInvalid={errors.dob || (showErrors && !this.state.fields["dob"])}
                                            inputErrorMsg={errors.dob}
                                        />
                                    </div>
                                    <div className="col-12 col-md-6 form-group">
                                        <GenericInput placeholder="First Name"
                                            value={this.state.fields["firstName"]} name="firstName"
                                            onChange={(e, value, isValid) => { this.onInputChange(e, "firstName", isValid) }}
                                            required
                                            inputErrorMsg={errors.firstName}
                                            showClearBtn
                                        />
                                    </div>
                                    <div className="col-12 col-md-6 form-group">
                                        <GenericInput placeholder="Last Name"
                                            value={this.state.fields["lastName"]} name="lastName"
                                            onChange={(e, value, isValid) => { this.onInputChange(e, "lastName", isValid)}}
                                            required
                                            inputErrorMsg={errors.lastName}
                                            showClearBtn
                                        />
                                    </div>
                                    <div className="col-12 form-group">
                                        <ZipCode placeholder="Zip Code"
                                            value={this.state.fields["zipCode"]} name="zipCode"
                                            onChange={(e, isValid) => { this.onInputChange(e,"zipCode",isValid); }}
                                            maxLength={5}
                                            inputErrorMsg={errors.zipCode}
                                            required
                                            showClearBtn
                                            showAsInvalid={errors && errors.zipCode}
                                        />
                                    </div>                                
                                    <div className="col-12 form-group">
                                        {serviceWaitings ?
                                            <Spinner />
                                            :
                                            <input className="btn btn-primary" type="submit" value="Retrieve Username" onClick={this.getUserName} disabled={!isClientSide} />
                                        }
                                    </div>
                                </React.Fragment>
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

const mapStateToProps = (state) => {
    return {
        helpDeskNumber: state.session.serverData ? state.session.serverData.helpDeskNumber : "",
        serviceWaiting : state.header.forgotUserNameWaiting,
        serviceError : state.header.forgotUserNameError,
        successResponse :  state.header.forgotUserNameSuccessMessage,
        failureResponse: state.header.forgotUserNameFailureMessage        
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        onForgotBtnClick: (email, dob, firstname, lastname, zipcode) => {
            dispatch({
                type: types.FORGOT_USERNAME_START,
                Email: email,
                DOB: dob,
                FirstName: firstname,
                LastName: lastname,
                ZipCode: zipcode
            });
        } ,
        ClearForgotState: () => {
            dispatch({
                type: types.FORGOT_USERNAME_CLEAR,
            });
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ForgotUsername);

